export const env= {
  baseUrl: 'https://api.fastswiff.com/dashboard/api',
  baseUrlMerchant: 'https://api.fastswiff.com/dashboard/api',
  baseUrlwallet: 'https://api.fastswiff.com/store/api',
}

export const environment = {
  production: true,
  clientsidelogflag: 0,
  mode: 0,
  defaultResellerId: 11000,
  BankAccountverficationMerchantkeyid:8615,
  resellerAppBaseUrl: '',
  SecretKey:"4512631236589784",
   GetAuthencticationKey:'VirtualPOS',
   EncryptionPassword:"P@yG!123",
  GetAuthenticationToken:"C2-53-D9-C3-38-D9-D9-32-4F-81-28-3A-6F-40-ED-1E-EC-20-25-E1-A9-DE-0E-A5-DC-38-41-47-A4-BA-35-42-4F-4D-4D-61-68-61-64-65-76-23",
  ImagePathUrl: 'https://fastswiff.com/assets/images/',
  merchantApiBaseUrl: 'http://eaglemerchantapi.azurewebsites.net/api',
  serviceApiBaseUrl: '',
  authenticationUrl: env.baseUrl + '/User/Authenticate',
  singupUrl: env.baseUrl + '/Account/MerchantRegister',
  fileUploadUrl: env.baseUrl + '/Account/UploadMerchantFile',
  MerchantFileUpload: env.baseUrl + '/Account/upload',

  userSignupUrl: env.baseUrl + '/Account/UserRegister',
  merchantlistUrl: env.baseUrl + '/reseller/Merchants',
  merchantUrl: env.baseUrl + '/reseller/Merchant',
  merchantdetailUrl: env.baseUrl + '/reseller/MerchantDetail',
  getEmailverified: env.baseUrl + '/Account/Confirm',
  forgotPassword: env.baseUrl + '/Account/ForgotPassword',
  changeTempPassword: env.baseUrl + '/Account/ChangeTempPassword',
  resetPassword: env.baseUrl + '/Account/ResetPassword',
  resetExpPasswordUrl: env.baseUrl + "/Account/ResetExpPassword",
  checkAdminEmailIdUrl: env.baseUrl + '/Account/CheckEmailDuplicate',
  merchantuserdetailsUrl: env.baseUrl + "/Account/GetMerchantUserDetails",
  checkUserEmailAddressUrl: env.baseUrl + "/Account/CheckUserEmailDuplicate",
  isValidMerchantKeyIdUrl: env.baseUrl + "/Account/IsValidMerchantKeyId",
  ProfileUrl: env.baseUrl + '/user/GetUser',
  userEditProfileUrl: env.baseUrl + '/user/editProfile',
  //userProfileUrl: 'https://api.fastswiff.com/service/api' + '/VirtualWallet/ChangePassword',
  // ChangeUserPasswordUrl: env.baseUrl + '/user/ChangeUserPassword',
  checkOldPasswordUrl: env.baseUrl + '/user/VerifyOldPassword',
  UpdateProfileUrl: env.baseUrl + '/user/UpdateUserProfile',
  resellerinfoesurl: env.baseUrl + "/Account/Resellerinfoes",
  // EcomSolutions
  getPayNows: env.baseUrl + '/EcomSolutions/ManagePayNow',
  addPayNow: env.baseUrl + '/EcomSolutions/NewPayButton',
  getPayNow: env.baseUrl + '/EcomSolutions/DetailPayNow',
  updatePayNow: env.baseUrl + '/EcomSolutions/UpdatePayButton',
  deletePayNow: env.baseUrl + '/EcomSolutions/DeletePayNow',
  ViewCodeUrl: env.baseUrl + '/EcomSolutions/ViewCodePayNow',
  AddQuickPaySettingsUrl: env.baseUrl + '/QuickPay/AddQuickPay',
  addAdvancedQuickPayServiceUrl: env.baseUrl + '/QuickPay/AddAdvancedQuickPayServices',
  createAdvancecQuickPayUrl: env.baseUrl + '/QuickPay/CreateAdvancecQuickPay',
  GetQuickPayUrl: env.baseUrl + '/QuickPay/GetQuickPay',
  getAdvancedQuickPayServicesUrl: env.baseUrl + '/QuickPay/GetAdvancedQuickPayServicesList',
  ManageQuickPayUrl: env.baseUrl + '/QuickPay/ManageQuickPay',
  ViewQuickPayDetailsUrl: env.baseUrl + '/QuickPay/GetQuickPayDetailsById',
  editQuickPayDataUrl: env.baseUrl + '/QuickPay/UpdateQuickPayData',
  deleteQuickPayDataUrl: env.baseUrl + '/QuickPay/DeleteQuickPayData',
  deleteAdvancedServiceDataUrl: env.baseUrl + '/QuickPay/UpdateAdvancedServiceStatus',
  checkDuplicateQuickCodeUrl: env.baseUrl + '/QuickPay/GetQuickPayDetailsByCode',
  checkDuplicateServiceNameUrl: env.baseUrl + '/QuickPay/GetQuickPayServicesByServiceName',
  getPayNowtransactiondetails: env.baseUrl + '/EcomSolutions/TransactionDetails',
  //FilterManagePaybuttonUrl :env.baseUrl + '/EcomSolutions/Vpos_GetPayNowFilterDetails_Sp',
  FilterManagePaybuttonUrl :env.baseUrl + '/EcomSolutions/GetPayNowFilterDetails',

  // Transaction
  NewTransactionUrl: env.baseUrl + '/Transaction/Pay',
  GetTransactionUrl: env.baseUrl + '/Transaction/Manage',
  GetServiceStatusUrl: env.baseUrl + '/Transaction/GetServiceStatus',
  ViewTransactionUrl: env.baseUrl + '/Transaction/Details',
  getTransactionDetailsByTypeUrl: env.baseUrl + '/Transaction/TransactionDetailsByType',
  VoidTransactionUrl: env.baseUrl + '/Transaction/VoidTransaction',
  CaptureTransactionUrl: env.baseUrl + '/Transaction/CaptureTransaction',
  getStoreCardsByMerchantId: env.baseUrl + '/Transaction/GetStoreCards',
  getStoreCardByCardNo: env.baseUrl + '/Transaction/DetailsByCardNo',
  ManageMerchantStatementsUrl: env.baseUrl + '/Transaction/GetMerchantStatementsList',
  getMerchantStatementDetailsUrl: env.baseUrl + '/Transaction/GetMerchantStatementDetails',
  getCurrentMonthStatementDetailsUrl: env.baseUrl + '/Transaction/GetCurrentMonthStatementDetails',
  GetMerchantOnboardStatus :"https://api.fastswiff.com/dashboard/api/Account/GetMerchantOnboardStatus",
  ManagePaymentOrdersUrl:env.baseUrl + '/Transaction/GetPaymentOrdersList',
  viewPaymentOrderDetailsUrl:env.baseUrl + '/Transaction/GetPaymentOrderDetails',
  GetOrderDetails:env.baseUrl+ '/Transaction/GetOrderDetails',
  GetSplitOrderDetails:env.baseUrl+ '/Transaction/GetSplitOrderDetails',
  filterPaymentOrdersUrl:env.baseUrl + '/Transaction/GetFilteredPaymentOrdersList',
  getTransactionGraph:"https://api.fastswiff.com/dashboard/api/Reports/GetTransactionGraph",
  // Batch
  GetBatchesUrl: env.baseUrl + '/Batch/GetBatches',
  BatchCloseUrl: env.baseUrl + '/Batch/BatchClose',
  GetBatchDetailUrl: env.baseUrl + '/Batch/GetBatcheDetail',
  GetSettledTransactionUrl: env.baseUrl + '/Batch/GetSettledTransactions',
  getMerchantAgreementUsingName:'https://api.fastswiff.com/mscommonService/api/Kyc/GetMerchantAgreementUsingName',
  // Settings
  getMerchantSettingsUrl: env.baseUrl + '/MerchantSettings/Index',
  getMerchantSettingsByIdUrl: env.baseUrl + '/MerchantSettings/GetMerchantSettingsById',
  updateMerchantSettingsUrl: env.baseUrl + '/MerchantSettings/UpdateMerchantSettings',
  getMerchantLogoUrl: env.baseUrl + '/MerchantSettings/GetMerchantBusinessLogo',
  uploadLogoUrl: env.baseUrl + '/MerchantSettings/UpdateBoardingKYCData',
  getMerchantKycDataUrl:env.baseUrl + '/MerchantSettings/GetKycBoardingData',
  MerchantDocumentUploadUrl: env.baseUrl + '/MerchantSettings/AddMerchantDocument',
  GetEsignProcessStatus: env.baseUrl +
  '/Account/GetEsignProcessStatus',
  GetDigioandPaygdetails: env.baseUrl + '/User/GetDigioandPaygdetails',
  AddMerchantSettingsUrl: env.baseUrl + '/MerchantSettings/Create',
  getMerchantUsersList: env.baseUrl + '/MerchantSettings/MerchantUsersList',
  approveRejectUser: env.baseUrl + '/MerchantSettings/ApproveRejectUser',
  viewMerchantUser: env.baseUrl + '/MerchantSettings/ViewMerchantUser',
  assignRoleToUser: env.baseUrl + '/MerchantSettings/AssignRoleToUser',
  updateRole: env.baseUrl + '/MerchantSettings/UpdateUserRole',
  updateUserRole:env.baseUrl+'/MerchantSettings/UpdateUserRole',
  getSelectedRole: env.baseUrl + '/MerchantSettings/GetSelectedRole',
  createNewRole: env.baseUrl + '/MerchantSettings/NewRole',
  getModules: env.baseUrl + '/MerchantSettings/GetModules',
  getRoles: env.baseUrl + '/MerchantSettings/RolesByMerchantKeyId',
  getRolesPermissions: env.baseUrl + '/User/GetRolesPermissions',
  getUserPermissions: env.baseUrl + '/User/GetUserPermissions',
  getUserRoleBasedPermissions:env.baseUrl + '/User/GetUserRoleBasedPermissions',
  createAuthenticationUrl: env.baseUrl + '/MerchantSettings/Authentication',
  GetAuthenticationDetails: env.baseUrl + '/MerchantSettings/GetAuthentication',

  // Invoice
  newInvoiceUrl: env.baseUrl + '/Invoice/NewInvoice',
  invoicelistUrl: env.baseUrl + '/Invoice/Manage',
  getInvoiceUrl: env.baseUrl + '/Invoice/Details',
  viewInvoiceUrl: env.baseUrl + '/Invoice/Details',
  updateInvoiceUrl: env.baseUrl + '/Invoice/UpdateInvoice',
  deleteInvoiceUrl: env.baseUrl + '/Invoice/DeleteInvoice',
  SendReminder: env.baseUrl + '/Invoice/SendReminder',
  TemplateByMerchantKeyIdUrl: env.baseUrl + '/Invoice/InvoiceTemplateByMerchantKeyId',
  getInvoiceTemplatesUrl: env.baseUrl + '/Invoice/InvoiceTemplatesList',
  invoiceDataSettingsUrl: env.baseUrl + '/Invoice/InvoiceDataSettings',

  //PrepaidCards
  newPrepaidCard: env.baseUrl + '/PrepaidCards/IssueNewCard',
  getPrepaidCardsList: env.baseUrl + '/PrepaidCards/Manage',
  viewCardDetails: env.baseUrl + '/PrepaidCards/Details',
  addBalanceToCard: env.baseUrl + '/PrepaidCards/AddBalanceToCard',
  deactivateTheCard: env.baseUrl + '/PrepaidCards/DeactivateTheCard',
  activateTheCard: env.baseUrl + '/PrepaidCards/ActivateTheCard',
  CardTransactionHistory: env.baseUrl + '/PrepaidCards/PrepaidCardActivities',
  prepaidCardFilterdataurl: env.baseUrl + '/PrepaidCards/GetPrepaidCardFilterdetails',
  prepaidCardTransactionFilterdataurl: env.baseUrl + '/PrepaidCards/PrepaidCardFilteredActivities',

  // FutureBillings
  getFutureBillingsListUrl: env.baseUrl + '/FutureBilling/FutureBillings',
  getFutureBillingById: env.baseUrl + '/FutureBilling/GetFutureBilling',
  getVaultsByMerchantId: env.baseUrlMerchant + 'FutureBilling/GetVaults',
  getVaultsByEmailUrl: env.baseUrlMerchant + 'FutureBilling/GetVaultsByEmail',
  createFutureBillingUrl: env.baseUrlMerchant + 'FutureBilling/NewFutureBilling',
  modifyFutureBillingUrl: env.baseUrlMerchant + 'FutureBilling/ModifyFutureBilling',
  deleteFutureBillingUrl: env.baseUrlMerchant + 'FutureBilling/DeleteFutureBilling',
  AddNewCardUrl: env.baseUrlMerchant + 'FutureBilling/AddWallet',
  getVaultsById:env.baseUrl + "/FutureBilling/GetVaultsById",
  checkDuplicatePlanNames:env.baseUrl + "/FutureBilling/CheckDuplicatePlan",
  checkRecurringBillingStatus:env.baseUrl + "/FutureBilling/CheckRecurringBillingStatus",
  GetLatestMerchantSalesContact: env.baseUrl +'/MerchantSettings/GetLatestMerchantSalesContact',
  GetDashBoardQuickPayLink :env.baseUrl + '/QuickPay/GetDashBoardQuickPayLink',
  // products
  getProducts: env.baseUrlMerchant + 'product/GetProductBySP',
  // getProducts: "https://virtualposapi.azurewebsites.net/api/" + "product/GetProducts",
  // ViewProduct: "https://virtualposapi.azurewebsites.net/api/" + "product/GetProduct",
  createProductUrl: env.baseUrlMerchant + 'Product/AddProduct',
  createProductPriceUrl: env.baseUrlMerchant + 'Product/AddProductPrice',
  getProductPriceByProductIdUrl: env.baseUrlMerchant + 'Product/GetProductPriceByProductId',
  updateProductUrl: env.baseUrlMerchant + 'Product/UpdateProduct',
  updateProductPriceUrl: env.baseUrlMerchant + 'Product/UpdateProductPrice',
  deleteProductUrl: env.baseUrlMerchant + 'Product/DeleteProduct',
  deleteProductPriceUrl: env.baseUrlMerchant + 'Product/DeleteProductPrice',
  addCouponsToProductCodeUrl: env.baseUrlMerchant + 'Product/AddCouponsToProductCode',
  addquantityToProduct: env.baseUrlMerchant + 'Product/AddProductLedgers',
  GetAddedCouponsByProductId: 'http://eagleserviceapi.azurewebsites.net/api/' + 'Coupon/GetCouponsByProductId', // need to cross check by navaneetha
  GetProductByProductId: env.baseUrlMerchant + 'Product/GetProductByProductId',
  UploadProductFile: env.baseUrlMerchant + 'Product/UploadFiles',
  GetProductLedgerUrl: env.baseUrlMerchant + 'Product/GetProductLedgers',
  getAppliedCouponsforProduct: env.baseUrlMerchant + 'Coupon/GetCouponsBySP',
  getproductlistforAppliedCoupons: env.baseUrlMerchant + 'product/GetCouponProductBySP',
  GetProductByProductCode: env.baseUrlMerchant + 'product/GetProductByProductCode',

  // For Coupons
  // getCoupons: env.baseUrlMerchant + "Coupon/Manage",
  // ViewCoupons: env.baseUrlMerchant + "Coupon/Details",
  getCoupons: env.baseUrlMerchant + 'Coupon/GetCouponsManageBySP',
  ViewCoupons: env.baseUrlMerchant + 'Coupon/DetailCouponsBySP',
  NewCoupons: env.baseUrlMerchant + 'Coupon/Add',
  DeleteCoupons: env.baseUrlMerchant + 'Coupon/Delete',
  AddProductsToCouponCode: env.baseUrlMerchant + 'Coupon/AddProducts',
  GetCouponByCouponCode: env.baseUrlMerchant + 'Coupon/GetCouponByCouponCode',

  // For AddonBusiness
  newBusinessAccUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/Add',
  accountsListUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/Manage',
  accountDatasListUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/ManageAccountData',
  newAccSettingsUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/AddSettings',
  checkAccountTypesListUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/CheckDuplicateTypes',
  checkDuplicateAccountUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/CheckDuplicateAccounts',
  checkDuplicateAccountsWithBNameUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/CheckAccountsByBusinessName',
  updateBusinessAccountUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/UpdateBusinessAccount',
  deleteBusinessAccountUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/DeleteBusinessAccount',
  updateBusinessAccountDataUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/UpdateBusinessAccountData',
  viewBusinessAccUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/BusinessAccountDetails',
  viewBusinessAccountDataUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/BusinessAccountDataDetails',
  getMerchantQRCode:"https://api.fastswiff.com/dashboard/api/Transaction/GenarateQrCode",
  GetTotalTranReportsByPaymentMethod_V1 :"https://api.fastswiff.com/dashboard/api/Reports/GetTotalTranReportsByPaymentMethod_V2",
  GetMerchantServicesAndFeesList :"https://api.fastswiff.com/dashboard/api/Account/GetMerchantServicesAndFeesList",
  // For Coupons
  viewAccountSettingUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/BusinessAccountSettingsDetatils',
  updateAccountSettingUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/UpdateAccountSettings',
  createBusinessAccountDataUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/AddAccountData',
  uploadFileUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/UploadFiles',
  deleteAccountDataUrl: env.baseUrlMerchant + 'AddOnBusinessAccount/DeleteAccountData',
  getMerchantInfoUrl: env.baseUrl + '/Home/MerchantDetails',

  // For Vault
  getVaultUrl: env.baseUrl + '/Vault/Manage',
  ViewVaultUrl: env.baseUrl + '/Vault/Detail',
  AddVaultUrl: env.baseUrl + '/Vault/Add',
  DeleteVaultUrl: env.baseUrl + '/Vault/Delete',
  GetVaultByEmailAccountNoUrl: env.baseUrl + '/Vault/GetWalletByEmailAccountno',

  // Reports
  getTransactionSummaryReport: env.baseUrl + '/Reports/GetTransactionSummary',
  getTransactionReportsUrl: env.baseUrl + '/Reports/GetTransactionReports',
  getTranReportsByPaymentMethodUrl: env.baseUrl + '/Reports/GetTranReportsByPaymentMethod',
  getTranReportsByDateRangeUrl: env.baseUrl + '/Reports/GetTransactionReportsByDateRange',
  getDateRangeReportsUrl: env.baseUrl + '/Reports/GetTranReportsByPaymentMethodByDateRange',
  getSettledTransactionsReport: env.baseUrl + '/Batch/GetSettledTransactionReports',
  ViewSettledTransaction: env.baseUrl + '/Batch/ViewSettledTransaction',

  // payProfiles
  AddAddressToPayProfileService: 'api/pay_profile/addAddressToPayprofile',
  AddDataToPayProfileService: 'api/pay_profile/addDataToPayProfile',
  CreateService: 'PayProfile/create',
  InsertPayProfileDocuments: 'PayProfile/InsertPayProfileDocuments',
  GetAddressFromGeolocationService: 'api/pay_profile/getAddressFromGeoLocation',
  GetDashboardData: 'Dashboard/GetDashboardData',
  GetCityListForStateService: 'api/pay_profile/getCityListForState',
  GetDetailsForAddDataPageService: 'PayProfile/getDetailsForAddDataPage',
  GetPayProfileSettingsService: 'PayProfile/getPayProfileSettings',
  GetPayProfileUsersService: 'api/pay_profile/getPayProfileUsers',
  GetPaymentReceiptSettingsService: 'PayProfile/getPaymentReceiptSettings',
  GetStatesListService: 'api/pay_profile/getStatesList',
  ShareLinkOnEmailService: 'api/pay_profile/shareLinkOnEmail',
  ShareLinkOnMobileService: 'api/pay_profile/shareLinkOnMobile',
  UpdatePayProfileBasicDetailsService: 'api/pay_profile/updatePayProfileBasicDetails',
  UpdatePayProfileSettingsService: 'PayProfile/updatePayProfileSettings',
  UpdatePaymentReceiptSettingsService: 'PayProfile/updatePaymentReceiptSettings',
  UploadDataInBulkWithExcelService: 'PayProfile/SaveListofSmartCollectDetails',
  customerAppUrl: 'https://fastswiff.com/consumer/#/',
  DashboardDataDashboardListReportName: 'UspPayProfileDashboardlist',
  DashboardDataPayProfileDashboardCountnew: 'UspPayProfileDashboardCountnew',
  DashboardDataGetProfileViewCount: 'GetProfileViewCount',
  DashboardDataUspPayprofileview: 'UspPayprofileview',
  updatepayprofilestatusService: 'PayProfile/updatepayprofilestatus',
  DashboardDataGetPayProfileRevenueService: 'GetPayProfileRevenue',
  DashboardDataUspPayProfileTranactionlistlist: 'UspPayProfileTranactionlistlist',
  DashboardDataGetPayProfileCount: 'GetPayProfileCount',
  TransactionDetailsByTypeService: 'Transaction/TransactionDetailsByType',
  GetTransactiondetailsByuniqueidService: 'PayProfile/GetPayProfilesSmartCollectDetailbyTransactionId',
  GetDetailsForAddDataPageSmartCollect: 'PayProfile/getDetailsForAddDataPageSmartCollect',
  GetCustomerSideDataForPayProfileURLService: "PayProfile/getCustomerSideDataForPayProfileURL",
  SaveListofSmartCollectDetailsService: "PayProfile/SaveListofSmartCollectDetails",
  transactionDetailscount :  env.baseUrl + "/Transaction/TransactionDetailscount",
  getSettlementDetails : env.baseUrl + "/Transaction/GetSettlementDetails",
  SmartCollectUsersService: "PayProfile/SmartCollectUsers",
  SmartCollectUserEntityDetails: "PayProfile/SmartCollectUserEntityDetails",
  CustomerSidePayProfileURL: "https://fastswiff.com/consumer/#/pay-profile/",
  UpdateBusinessDetails: "PayProfile/UpdateBusinessDetails",
  UploadCKEditorImageAndGetURL: "PayProfile/UploadCKEditorImageAndGetURL",

  // Bidding
  BiddingGetOpenBiddingProfileService: 'Bidding/GetOpenBiddingProfile',
  BiddingCreateStep_1_1Service: 'Bidding/Create/Step_1_1',
  BiddingCreateStep_1_2Service: 'Bidding/Create/Step_1_2',
  BiddingCreateStep_1_3Service: 'Bidding/Create/Step_1_3',
  BiddingCreateStep_1_4Service: 'Bidding/Create/Step_1_4',
  BiddingCreateStep_2Service: 'Bidding/Create/Step_2',
  BiddingCreateStep_3Service: 'Bidding/Create/Step_3',
  BiddingCreateStep_4Service: 'Bidding/Create/Step_4',
  BiddingCreateStep_5Service: 'Bidding/Create/Step_5',
  BiddingCreateStep_6Service: 'Bidding/Create/Step_6',
  BiddingGetDraftDataService: 'Bidding/Create/GetDraftData',


  getTotalTransactionReportsUrl:env.baseUrl + "/Reports/GetTotalTransactionReports",
  getTotalTranReportsByPaymentMethodUrl:env.baseUrl + "/Reports/GetTotalTranReportsByPaymentMethod",

  createNewMerchantUrl: env.baseUrl + '/Account/CreateNewMerchant',
  saveBusinessAddressUrl: env.baseUrl + '/Account/SaveBusinessAddress',
  saveBusinessDetailsUrl: env.baseUrl + '/Account/SaveBusinessDetails',
  saveBusinessContactDetailsUrl: env.baseUrl + '/Account/SaveBusinessContactDetails',
  saveCompanyDocumentsUrl: env.baseUrl + '/Account/SaveCompanyDocuments',
  saveBusinessOwnerDetailsUrl: env.baseUrl + '/Account/SaveBusinessOwnerDetails',
  saveOwnerContactDetailsUrl: env.baseUrl + '/Account/SaveOwnerContactDetails',
  saveBankDetailsUrl: env.baseUrl + '/Account/SaveBankDetails',
  saveReferenceDetailsUrl: env.baseUrl + '/Account/SaveReferenceDetails',
  demoUserActivationUrl: env.baseUrl + "/Account/DemoUserActivation",
  getBusinessAddressDetailsUrl: env.baseUrl + '/Account/GetBusinessAddressDetails',
  getBankAccountDetailsUrl: env.baseUrl + '/Account/GetBankAccountDetails',
  getMerchantDetailsUrl: env.baseUrl + '/Account/GetMerchantDetails',
  getBoardingKYCDatasUrl: env.baseUrl + '/Account/GetBoardingKYCDatas',

  redirectLinkFromVPOSAddOnBusinessTOWallet: "https://fastswiff.com/wallet/addonbusiness/addonbusinessbycode",
  paymentLinkFromAddOnDataView: "https://fastswiff.com/walletaddonbusiness",
  QuickpayPageUrl: "https://fastswiff.com/wallet/quickpay/quickpay;QuickCode=",
  TransactionCount: env.baseUrl + "/Transaction/TransactionDetailscount",
  viewFilterdataurl: env.baseUrl + "/Transaction/Filtertransactiondetails",
  batchesFilterdataurl: env.baseUrl + "/Batch/GetBatchesFilterdetails",

  PaymentLedgerUrl:env.baseUrl + '/Transaction/GetPaymentLedger',
  PaymentLedgerFilterdataurl:env.baseUrl + "/Transaction/GetPaymentledgerFilterdetails",
 GetPaymentLedgerDetailsUrl:env.baseUrl + '/Transaction/GetPaymentLedgerDetails',
  ManageFeeReportUrl: env.baseUrl + '/Transaction/GetFeeReport',
  FilterFeedataurl: env.baseUrl + "/Transaction/GetFilteredFeeReport",

  invoiceFilterdataurl: env.baseUrl + "/Invoice/GetinvoiceFilterdetails",
  getFilterPayNowtransactiondetails: env.baseUrl + '/EcomSolutions/FilterPaybuttonTransactionDetails',


  // SettlementVendors

  getSettlementVendorList: env.baseUrl + '/SettlementVendors/Manage',
  newSettlementVendor: env.baseUrl + '/SettlementVendors/NewSettlementVendor',
  viewSettlementVendorDetails: env.baseUrl + '/SettlementVendors/Details',
  editSettlementVendor: env.baseUrl + '/SettlementVendors/UpdateSettlementVendor',
  deleteSettlementVendor: env.baseUrl + '/SettlementVendors/DeleteSettlementVendor',

  addcoupon: env.baseUrl + '/Coupons/NewCoupon',
  getcoupons: env.baseUrl + '/Coupons/ManageCoupons',
  Viewcoupon: env.baseUrl + '/Coupons/DetailCopon',
  Deletecoupon: env.baseUrl + '/Coupons/RemoveItem',

  getcoupondetails: env.baseUrl + '/Coupons/couponcodedetails',
  viewCouponcodeFilterdataurl: env.baseUrl + "/Coupons/Filtercouponcodedetails",

  GetCartdetails: env.baseUrl + '/Cart/CartDetails',
  ViewCart: env.baseUrlwallet + '/Cart/ItemDetails',
  cartstatus: env.baseUrlwallet + '/Cart/UpdateOrderStatus',
  CartPageUrl: 'https://fastswiff.com/wallet/pay/cart?cartid=',
  HomeUrl: 'http://fastswiff.com/merchant/#/home/welcomepayg',
  CartFilterdataurl: env.baseUrl + "/Cart/CartFilter",
  transactionhistory: env.baseUrl + '/EcomSolutions/paynowstransactionlist',

  QuickPayTransactionUrl: env.baseUrl + '/QuickPay/GetQuickPayTransactions',

  getFilterQuickPaytransactiondetails: env.baseUrl + '/QuickPay/GetQuickPayTransactionsFilter',
  QuickPayFilterdataUrl: env.baseUrl + '/QuickPay/GetQuickPayDataFilter',


  supportLoginUrl: env.baseUrl + "/User/Authenticate",
  RefundTransactionUrl: env.baseUrl + '/Transaction/RefundTransaction',
  CheckUpiStatusUrl: env.baseUrl + '/Transaction/StatusCheck',
  getQuickPayTransactionDetailsUrl: env.baseUrl + '/QuickPay/GetQuickPayTransactionDetails',
  checkDistributorUrl:env.baseUrl + "/Account/CheckDistributorId",
  checkPartnerIdUrl:env.baseUrl + "/Account/CheckPartnerId",


  // POS Related URLs

  DomainUrl:'https://api.fastswiff.com/POS/api/Business/GetOnlineStoreDomainurlDetail',
  GetBusinessInfoUrl: 'https://api.fastswiff.com/POS/api/Business/GetSubcriptionDetail',
  UpdateBusinessinfoUrl: 'https://api.fastswiff.com/POS/api/Business/UpdateSubcription',
  AddBusinessUrl: 'https://api.fastswiff.com/POS/api/Business/RegisterSubcription',
  GetCustomerIDDetail: 'https://api.fastswiff.com/POS/api/Business/GetCustomerID',
  AddTransactionReportingUrl: 'https://api.fastswiff.com/POS/api/Setup/AddReportingSteup',
  GetOrderReceiptlistUrl: 'https://api.fastswiff.com/POS/api/Setup/GetOrderReceipList',
  GetOrderSetupListUrl: 'https://api.fastswiff.com/POS/api/Setup/GetOrderSetupList',
  GetEmployeeDetail1Url: 'https://api.fastswiff.com/POS/api/Business/GetEmployeeID',
  GetTenderDetailidUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTenderSetupTenderType',
  UpdateTransactionReportingUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdateReportingSteup',
  GetTransactionReportingDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTransactionReportingDetail',
  GetCategoryTaxFeeListUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTaxesFeeSetupList',

  GetBusinessHoursListUrl: 'https://api.fastswiff.com/POS/api/Setup/GetBusinessHoursList',

  GetBusinessHoursDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetBusinessHoursDetail',
  AddBusinessHoursUrl: 'https://api.fastswiff.com/POS/api/Setup/AddBusinessHours',
  UpdateBusinessHoursUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdateBusinessHours',

  GetCustomerListUrl: 'https://api.fastswiff.com/POS/api/Business/GetCustomerList',
  GetCustomerDetailUrl: 'https://api.fastswiff.com/POS/api/Business/GetCustomerDetail',
  AddCustomerUrl: 'https://api.fastswiff.com/POS/api/Business/AddCustomer',
  UpdateCustomerUrl: 'https://api.fastswiff.com/POS/api/Business/UpdateCustomer',

  GetEmployeeListUrl: 'https://api.fastswiff.com/POS/api/Business/GetEmployeeList',
  GetEmployeeDetailUrl: 'https://api.fastswiff.com/POS/api/Business/GetEmployeeDetail',
  AddEmployeeUrl: 'https://api.fastswiff.com/POS/api/Business/AddEmployee',
  UpdateEmployeeUrl: 'https://api.fastswiff.com/POS/api/Business/UpdateEmployee',

  GetEmployeeShiftListUrl: 'http://localhost:60472/api' + '',
  GetEmployeeShiftDetailUrl: 'http://localhost:60472/api' + '',
  AddEmployeeShiftUrl: 'http://localhost:60472/api' + '',
  UpdateEmployeeShiftUrl: 'http://localhost:60472/api' + '',

  GetItemListUrl: 'https://api.fastswiff.com/POS/api/Inventory/GetPosItemList',
  GetItemDetailUrl: 'https://api.fastswiff.com/POS/api/Inventory/GetPosItemDetail',
  AddItemUrl: 'https://api.fastswiff.com/POS/api/Inventory/AddItem',
  UpdateItemUrl: 'https://api.fastswiff.com/POS/api/Inventory/UpdateItem',
  GetItemList:'https://api.fastswiff.com/POS/api/Inventory/GetPosItems',
  GetItemCategoryListUrl: 'https://api.fastswiff.com/POS/api/Inventory/GetCategoryList',
  GetItemCategoryList:'https://api.fastswiff.com/POS/api/Inventory/GetPosCategory',
  GetItemCategoryDetailUrl: 'https://api.fastswiff.com/POS/api/Inventory/GetCategoryDetail',
  AddItemCategoryUrl: 'https://api.fastswiff.com/POS/api/Inventory/AddCategory',
  UpdateItemCategoryUrl: 'https://api.fastswiff.com/POS/api/Inventory/UpdateCategory',

  GetItemCategoryTaxFeeListUrl: 'http://localhost:60472/api' + '',
  GetItemCategoryTaxFeeDetailUrl: 'http://localhost:60472/api' + '',
  AddItemCategoryTaxFeeUrl: 'http://localhost:60472/api' + '',
  UpdateItemCategoryTaxFeeUrl: 'http://localhost:60472/api' + '',

  GetOrderTypeListUrl: 'https://api.fastswiff.com/POS/api/Setup/OrderTypeSetupList',
  GetOrderTypeDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/OrderTypeSetupDetail',
  AddOrderTypeUrl: 'https://api.fastswiff.com/POS/api/Setup/AddOrderTypeSetup',
  UpdateOrderTypeUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdateOrderTypeSetup',




  GetBusinesshoursFilterList:'https://api.fastswiff.com/POS/api/Setup/GetBusinessHoursFilterDataList',
GetItemCategoryFilterList:'https://api.fastswiff.com/POS/api/Inventory/GetPosCategoryFilterList',
FilteringOrderTypeDetails:'https://api.fastswiff.com/POS/api/Setup/GetOrderTypeFilterDataList',
FilteringTipsdetails:'https://api.fastswiff.com/POS/api/Setup/GetTipSetupfilterList',
FilteringTaxFeeDetails:'https://api.fastswiff.com/POS/api/Setup/GetPosTaxesFeeFilterList',
  FilteringPaymentListDetail:'https://api.fastswiff.com/POS/api/Setup/GetPaymentSetupList',
  GetPaymentSetupFilterList:'https://api.fastswiff.com/POS/api/Setup/GetPaymentSetupFilterList',








  GetOrderSetupDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetOrderSetupDetail',
  AddOrderSetupUrl: 'https://api.fastswiff.com/POS/api/Setup/AddOrderSetup',
  UpdateOrderSetupUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdateOrderSetup',

  GetOrderReceiptDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetOrderReceiptSetupDetail',
  AddOrderReceiptUrl: 'https://api.fastswiff.com/POS/api/api/Setup/AddOrderReceiptSetup',
  UpdateOrderReceiptUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdateOrderReceiptSetup',

  GetPaymentReceiptDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetPaymentReceiptSetupDetail',
  AddPaymentReceiptUrl: 'https://api.fastswiff.com/POS/api/Setup/AddPaymentReceiptSetup',
  UpdatePaymentReceiptUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdatePaymentReceiptSetup',

  GetPaymentSetupDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetPaymentSetupDetail',
  AddPaymentSetupUrl: 'https://api.fastswiff.com/POS/api/Setup/AddPaymentSetup',
  UpdatePaymentSetupUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdatePaymentSetup',

  GetTenderListUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTenderSetupList',
  GetTenderDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTenderSetupDetail',
  AddTenderUrl: 'https://api.fastswiff.com/POS/api/Setup/AddTenderSetup',
  UpdateTenderUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdateTenderSetup',

  GetUserRolesListUrl: 'http://localhost:60472/api' + '',
  GetUserRoleDetailUrl: 'http://localhost:60472/api' + '',
  AddUserRoleUrl: 'http://localhost:60472/api' + '',
  UpdateUserRoleUrl: 'http://localhost:60472/api' + '',

  GetTipsListUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTipSetupList',
  GetTipsDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTipSetupDetail',
  AddTipsUrl: 'https://api.fastswiff.com/POS/api/Setup/AddTipSetup',
  UpdateTipsUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdateTipSetup',

  GetTaxesFeeListUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTaxesFeeSetupList',
  GetTaxesFeeList:'https://api.fastswiff.com/POS/api/Setup/GetPosTaxesFee',
  GetTaxesFeeDetailUrl: 'https://api.fastswiff.com/POS/api/Setup/GetTaxesFeeSetupDetail',
  AddTaxesFeeUrl: 'https://api.fastswiff.com/POS/api/Setup/AddTaxesFeeSetup',
  UpdateTaxesFeeUrl: 'https://api.fastswiff.com/POS/api/Setup/UpdateTaxesFeeSetup',

  GetTaxesFeeExemptionRuleListUrl: 'http://localhost:60472/api' + '',
  GetTaxesFeeExemptionRuleDetailUrl: 'http://localhost:60472/api' + '',
  AddTaxesFeeExemptionRuleUrl: 'http://localhost:60472/api' + '',
  UpdateTaxesFeeExemptionRuleUrl: 'http://localhost:60472/api' + '',
  GetCustomerEmailVerfication: 'https://api.fastswiff.com/POS/api/Business/GetCustomerEmail',


  GetordermanagementListUrl: 'https://api.fastswiff.com/POS/api/Order/GetOrderList',
  Getorderdetails: 'https://api.fastswiff.com/POS/api/Order/GetPosOrderDetail',
  AddOrders: 'https://api.fastswiff.com/POS/api/Order/Create',
  getCoupondetails: 'https://api.fastswiff.com/POS/api/Order/ApplyCoupon',
  Getdetails: 'https://api.fastswiff.com/POS/api/Order/GetOrderdetails',

  GetCustomerEmailDetail: 'https://api.fastswiff.com/POS/api/Business/GetCustomerEmail',
  GetEmployeeEmailVerfication: 'https://api.fastswiff.com/POS/api/Business/GetEmployeeEmail',
  PaymentSetupDetailListUrl: 'https://api.fastswiff.com/POS/api/Setup/GetPaymentSetupList',

  GetcatedoryidList: 'https://api.fastswiff.com/POS/api/Inventory/GetCategoryidList',
  GetCategoryNameDetailUrl: 'https://api.fastswiff.com/POS/api/Inventory/GetCategoryNameDetail',
  CashTransaction: 'https://api.fastswiff.com/POS/api/Order/AddCashTransaction',
  EmailMobileOrder: 'https://api.fastswiff.com/POS/api/Order/EmailOrder',
  InsertPayGPaymentGatewaySetups: 'https://api.fastswiff.com/POS/api/Setup/AddPayGPaymentGatewaySetup',
  GetPenddingOrderListUrl:'https://api.fastswiff.com/POS/api/Order/GetPendingOrderList',
  GetOrderDashBoardListUrl:'https://api.fastswiff.com/POS/api/Order/GetCompleteOrderList',
  FilteringOrderDetails:'https://api.fastswiff.com/POS/api/Order/FilteringOrderDetail',
  GetCashTransactionDetail:'https://api.fastswiff.com/POS/api/Order/GetCashTransactionDetail',
  FilteringCustomerDetails:'https://api.fastswiff.com/POS/api/Business/FilteringCustomerDetail',
FilteringEmployeeDetails:'https://api.fastswiff.com/POS/api/Business/FilteringEmployeeDetail',
FilteringitemDetails:'https://api.fastswiff.com/POS/api/Inventory/FilteringItemDetail',


  ItemFileUplod:'https://api.fastswiff.com/POS/api/Inventory/ItemImageUpload',
  GetEmployeeEmailDetail:'https://api.fastswiff.com/POS/api/Business/GetEmployeeEmaildetails',
  GetEmployeeMobileDetail:'https://api.fastswiff.com/POS/api/Business/GetEmployeeMobiledetails',
  GetCustomermobileDetail:'https://api.fastswiff.com/POS/api/Business/GetCustomerMobile',
  posauthenticationUrl:'https://api.fastswiff.com/POS/api/Business/Authenticate',
  Ordercancelation:'https://api.fastswiff.com/POS/api/Order/Ordercancellation',

  Onlinestoreurl:"https://fastswiff.com/wallet/b/",
  BusinesslogoUploadUrl:'https://api.fastswiff.com/POS/api/Business/BusinessUpload',
  EasycollectFilterdataurl:env.baseUrlMerchant + '/AddOnBusinessAccount/ManageeasycollectFilterdetails',



  checkMobileOTPUrl: 'https://api.fastswiff.com/merchant/api' + '/User/CheckMobileOTP',
  resendMobileOTPUrl: 'https://api.fastswiff.com/merchant/api' + '/User/ResendMobileOtp',
  checkEmailOTPUrl: 'https://api.fastswiff.com/merchant/api' + '/User/CheckEmailOTP',
  agentconfirmMobileNoUrl: 'https://api.fastswiff.com/merchant/api' + '/User/UpdateAgentUserMobileConfirmation',
  agentconfirmEmailIdUrl: 'https://api.fastswiff.com/merchant/api' + '/User/UpdateAgentUserEmailConfirmation',
  createPassword: 'https://api.fastswiff.com/merchant/api' + '/User/CreatePassword',
  checkMMSUserdetailsUrl: 'https://api.fastswiff.com/merchant/api' + '/User/GetMMSUserDetails',
  resendEmailOTPUrl: 'https://api.fastswiff.com/merchant/api' + '/User/ResendEmailOtp',
  checkAdminMobileUrl: env.baseUrlMerchant + '/Account/CheckMobileDuplicate',
  checkUserdetailsUrl: "https://api.fastswiff.com/merchant/api" + "/User/GetUserDetailsByTypeAndEmail",
  forgotPasswords: 'https://api.fastswiff.com/merchant/api' + '/User/MMSForgotPassword',
 UpdateEmailurl: 'https://api.fastswiff.com/merchant/api' + '/User/EditMMSUserProfile',

 viewvendorFilterdataurl:env.baseUrl + '/SettlementVendors/ManageFiltervendorDetails',
  CouponFilterdataurl:env.baseUrl + '/Coupons/CouponsFiltervendorDetails',

  GetCouponCodedetails: env.baseUrl + '/Coupons/GetCouponCodedetails',

  createOrderUrl:env.baseUrl + '/Transaction/Create',
  createRecurringBillingUrl:env.baseUrl + "/FutureBilling/CreateRecurringBillingOrder",
  getMerchantFeeServicesListUrl: env.baseUrl + "/Account/GetMerchantServicesAndFeesList",
  getRecurringBillingFilterDataUrl:env.baseUrl + '/FutureBilling/GetRecurringBillingFilterdetails',
  getVaultFilteredDetailsUrl: env.baseUrl + '/Vault/GetVaultsFilterdetails',
  getMerchantBoardingHistoryUrl:env.baseUrl + "/Account/GetMercahntBoadingHistoriesData",
  getFutureBillingSchedulesListUrl: env.baseUrl + '/FutureBilling/GetRecurringBillingSchedulesDate',
  getFutureBillingSchedulesFilterUrl: env.baseUrl + '/FutureBilling/GetRecurringBillingSchedulesFilteredDate',
  updateRecurringBillingUrl: env.baseUrl + '/FutureBilling/UpdateRecurringBillingOrder',

  getRecurringBillingHistoryDetails:env.baseUrl + "/FutureBilling/GetRecurringBillingHistoryDetails",
  editRecurringBillingUrl:env.baseUrl + "/FutureBilling/UpdateRecurringBillingOrder",
  getmerchantServiceAndFeesListUrl: env.baseUrl + '/Transaction/GetMerchantServicesAndFeesList',
  ProcessPaymentUrl: 'https://fastswiff.com/pay/payment2?OrderKeyId=',



  AddMerchantSpecificSettings:env.baseUrl + "/MerchantSettings/MerchantSpecificSettings",
  getMerchantSpecificSettings:env.baseUrl + "/MerchantSettings/GetMerchantSpecificSettings",
  getFeeAndGSTReportsListUrl:env.baseUrl + '/Reports/GetFeeAndGSTMonthlyReportsList',
  getFeeAndGSTTranLevelListUrl: env.baseUrl + '/Reports/GetFeeAndGSTTranLevelList',
  getFeeAndGSTTranLevelFilterUrl: env.baseUrl + '/Reports/GetFeeAndGSTTranLevelFilter',

  getTransactionSummaryReportUrl: env.baseUrl + '/Reports/GetTransactionSummaryReports',
  getTransactionSummaryFilterUrl: env.baseUrl + '/Reports/GetTransactionSummaryFilter',
  getTransactionSummaryDetailsUrl: env.baseUrl + '/Reports/GetTransactionSummaryDetails',
  getFeeAndGSTCertificate: env.baseUrl + '/Reports/GetFeeAndGSTCertificate',
  // PayOut URLs

  newPayOuturl: env.baseUrl + '/PayOut/NewPayOut',
  getpayoutcontactList: env.baseUrl + '/PayOut/managePayOut',
  viewPayoutContactDetails: env.baseUrl + '/PayOut/Details',
  newVirtualinfo: env.baseUrl + '/PayOut/NewVirtualinfo',
  GetCustomerVirtualInfourl: env.baseUrl + '/PayOut/manageVirtualinfo',
  ViewCustomerVirtualAccounDetails: env.baseUrl + '/PayOut/CustomerVirtualAccounDetails',
  getGetTransactionList: env.baseUrl + '/PayOut/PayOuttransactionList',
  ViewPayOutTransactionDetailsurl: env.baseUrl + '/PayOut/ViewPayOutTransactionDetails',
  GetPayOutLedgersList: env.baseUrl + '/PayOut/managePayOutLedgers',
  ViewPayOutLedgerDetailsurl: env.baseUrl + '/PayOut/ViewPayOutLedgers',
  updatePayOutContactUrl: env.baseUrl + '/PayOut/EditPayOut',

  newBeneficiarieurl: env.baseUrl + '/PayOut/NewBenficiari',
  ViewPayOutBeneficiarieurl : env.baseUrl + '/PayOut/ViewPayOutBeneficiarie',
  viewBeneficiarieDetails:env.baseUrl + '/PayOut/ViewBeneficiarieDetails',



  DeletePayOutContactUrl: env.baseUrl + '/PayOut/DeletePayoutContact',
  DeleteVirtualinfoUrl: env.baseUrl + '/PayOut/DeleteVirtualinfo',
  updateVirtualinfoUrl: env.baseUrl + '/PayOut/UpdateVirtualinfo',
  viewPayOutFilterdataurl: env.baseUrl + '/PayOut/PayOutFilterdataurl',
  viewcustomerVirtualFilterdataurl: env.baseUrl + '/PayOut/PayOutcustomerVirtualinfo',

  viewPayouttransactionFilterdataurl: env.baseUrl + '/PayOut/PayOuttransactionFilterinfo',
  viewPayoutledgerFilterdataurl: env.baseUrl + '/PayOut/PayOuttledgerFilterinfo',
  GetCustomerkeyIDDetail: env.baseUrl + '/PayOut/PayOutDuplicateCustomerkeyid',

  UpdateBeneficiarieurl: env.baseUrl + '/PayOut/UpdatepayoutBeneficiarie',
  viewbenficiarieFilterdataurl: env.baseUrl + '/PayOut/ViewbenficiarieFilterdataurl',

  PayOutTransurl:'https://api.fastswiff.com/virtualPOS/api/PayOut/FundTransfer',
  // PayOutTransurl:'https://uatapi.fastswiff.com/payment/api/PayOut/FundTransfer',


  PayOutGetTransactionFee:'https://uatapi.fastswiff.com/payment/api/PayOut/GetTransactionFee',
  VerifyBeneficiaryurl:'https://api.fastswiff.com/virtualPOS/api/PayOut/InitiateBeneficiaryVerification',

  DeleteBeneficiarieUrl: env.baseUrl + '/PayOut/DeleteBeneficiarie',
  GetAuthenticationTokenpaymentApp: 'C2F980CF-4B66-452B-A4A7-F223ED7942AF',

  GetCustomerAccountkeyIDDetail: env.baseUrl + '/PayOut/PayOutDuplicateCustomerAccountkeyid',
  GetMerchantBusinessDetailsUrl: env.baseUrl + '/Reports/GetMerchantInfoes',

  GetpayoutBatchList: env.baseUrl + '/PayOut/PayOutBatches',
  ViewPayOutBatchDetailsView: env.baseUrl + '/PayOut/PayOutBatchesView',
  ViewPayOutBatchDetailsDetails: env.baseUrl + '/PayOut/PayOutBatchesdetails',
  ViewPayOutBatchDetailView: env.baseUrl + '/PayOut/PayOutBatchesdetailsView',

  CancellSchedulePaymenturl:'https://uatapi.fastswiff.com/payment/api/PayOut/CancellSchedulePayment',

  PayOutbatchesFilterdataurl: env.baseUrl + '/PayOut/PayOutBatchesFilters',
  ViewPayOutBeneficiarieListUrl: env.baseUrl + '/PayOut/PayOutContactBeneficiarieList',
  AddAccountBalanceurl: 'https://uatapi.fastswiff.com/payment/api/PayOut/CreateVirtualAccountBalance',
  getMerchantFeeServicesListSetupUrl: env.baseUrl + "/Account/GetMerchantServicesAndFeesSetupList",
  GetMerchantServicesAndFeesEsign: env.baseUrl + "/Account/GetMerchantServicesAndFeesEsign",
  PayOutBulkurl: env.baseUrl + "/PayOut/BulkTransactionUpload",
  getPayOutBulkUploadFileList: env.baseUrl + "/PayOut/PayOutBulkUploadFileList",
  ViewBulkUploadFilesUrl: env.baseUrl + "/PayOut/ViewBulkUploadFiles",
  GetBulkUploadFileListUrl: env.baseUrl + "/PayOut/PayOutGetBulkUploadFileList",
  GetBulkUploadFiledetailsurl: env.baseUrl + "/PayOut/GetBulkUploadFiledetails",
  Getbulkuploaddataurl:env.baseUrl + "/PayOut/GetBulkUploadFileFilteredData",



  GetUserPreferenceSettingsUrl: env.baseUrl + '/Transaction/GetUserPreferenceSettings',
  InserUserPreferenceSettingsUrl: env.baseUrl + '/Transaction/UserPreferenceSettings',
  UpdateManageTransactionSettingsUrl:env.baseUrl + '/Transaction/UpdateUserPreferenceSettings',

  RedirectUrl:'https://fastswiff.com/merchant/#/PayOut/AddBeneficiaries;Id=',
  RedirectViewbenficiary:'https://fastswiff.com/merchant/#/PayOut/ViewBeneficiaries;PayoutCustomerkeyId=',
  Verifybenficiary:'https://fastswiff.com/merchant/#/PayOut/ViewBeneficiaries;Id=',
  GetPayOutConatctBeneficiariesList: env.baseUrl + '/PayOut/PayOutBeneficiarieList',

  AddMobileMandatoryMerchantSpecificSettings:env.baseUrl + "/MerchantSettings/MerchantMobileNumbertSpecificSettings",

  getQuickcodeTransactionSummaryUrl: env.baseUrl + '/Reports/GetQuickcodeTransactionSummary',
  getFilteredTransactionSummaryUrl: env.baseUrl + '/Reports/GetFilteredQuickcodeTransactionSummary',
  GetTransactionListByQuickCodeandDate: env.baseUrl + '/Reports/GetTransactionsByCodeAndDate',
  // getBoardingdataUrl:'https://api.fastswiff.com/merchant/api' + '/Merchant/GetBoardingDocuments',
  GetResellerDetailsUrl:env.baseUrl + "/Account/GetResellerDetails",
  ViewPayOutNameDetails:'https://uatapi.fastswiff.com/payment/api/PayOut/GetContact',
  GetBeneficiarieBankDetailsurl:'https://uatapi.fastswiff.com/payment/api/PayOut/CheckBeneficiaryBankDetails',
  GetRecentTransactionList: env.baseUrl + '/PayOut/PayOutRecenttransactionList',
  GetDuplicateTaxFeeNameUrl:'https://api.fastswiff.com/POS/api'+'/Setup/GetDuplicateTaxFeeName',
  GetDuplicateProductCodeUrl:'https://api.fastswiff.com/POS/api/Inventory/Getproductdetails',

  AddBankdetails:env.baseUrl + "/MerchantSettings/AddBankdetails",
  getBankAccountChangeQueues: env.baseUrl + '/Account/GetBankAccountChangeQueues',
  // GetIFscCodeandAccountnuber: 'https://api.fastswiff.com/merchant/api' + '/Merchant/CheckAccountnumberIfscCode',
  GetIFscCodeandAccountnuber: env.baseUrl + '/Transaction/CheckAccountnumberIfscCode',
  GetChargeBackMaster:env.baseUrl+ '/MerchantSettings/GetChargeBackMaster',
  GetviewChargeBack: env.baseUrl + '/MerchantSettings/GetviewChargeBack',
  GetChargeBackDetail: env.baseUrl + '/MerchantSettings/GetChargeBackDetail',
  InsertDocument:'https://api.fastswiff.com/merchant/api'+'/Dispute/InsertChargebackDocument',
  SaveChargebackdetails:'https://api.fastswiff.com/merchant/api'+'/Dispute/SaveChargeBackDetailData',
  GetChargebackFilteredData: env.baseUrl + '/MerchantSettings/VPOSChargebackFilteredData',
  viewchargebackdetails:env.baseUrl + '/MerchantSettings/GetviewChargeBackdata',
  GetChargebackbytransactionId:env.baseUrl + '/Transaction/GetChargebackBytransactionid',

  GetposbackdataUrl:env.baseUrl + '/Transaction/Getposbackdata',
updateMerchantSettingspostdataUrl:env.baseUrl + '/MerchantSettings/Updatepostbackdata',


gettermsconditioncontent:env.baseUrl + '/Account/GetTermsandconditions',
GstNonEnrollment:env.baseUrl + '/Account/GetGstNonEnrollment',
GstMerchantagreementcontent:env.baseUrl + '/Account/GetMerchantagreement',
OrderUrl:'https://fastswiff.com/wallet/PosOrder/Orders?data=',
Getbusinesshoursweekdaysdays: 'https://api.fastswiff.com/POS/api/Setup/GetBusinessWeekDays',
CancelOrderDetails:env.baseUrl+ '/Transaction/CancelPaymentOrder',
SplitOrderDetails:env.baseUrl+ '/Transaction/SplitPaymentOrder',
updateMerchantSettingspayoutpostdataUrl:env.baseUrl + '/PayOut/UpdatePayoutpostbackdata',


GetGetNotificationList:env.baseUrl+ '/MobileNotification/GetMobileNotificationList',
notificationlistFilterdataurl:env.baseUrl+ '/MobileNotification/GetMobileNotificationFilterData',
AddVirtualAccount:'https://uatapi.fastswiff.com/payment/api/PayOut/PayoutCustomerVirtualAccount',
GetIfsccodedetails:'https://api.fastswiff.com/dashboard/api/PayOut/GetIfsccodedetails',
Getproductcodedatavalidation:env.baseUrlwallet+'/Pos/CheckProductData',
GetCustomerAccountIDDetail: env.baseUrl + '/PayOut/PayOutCustomerAccountiddetail',
CheckCustomerAccountdetail: env.baseUrl + '/PayOut/CustomerAccountDetails',

GetReserveFundDataUrl: env.baseUrl + '/Reports/GetReserveFund',
GetReserveFund: env.baseUrl + '/Reports/GetReserve',
GetReserveFundFilteredData: env.baseUrl + '/Reports/GetReserveFundReportFilter',

// PayOutApprovalDocument:env.baseUrl + '/PayOut/PayOutBankfileUpload',

GetPayOutAccountdetails:env.baseUrl + '/PayOut/GetPayOutAccountdetails',
ViewPayOutAccountdetails:env.baseUrl + '/PayOut/ViewPayOutAccountdetails',
AddPayoutbankdetails:env.baseUrl + '/PayOut/AddPayoutAccountDetails',
PayOutApprovalDocument:'https://uatapi.fastswiff.com/payment/api/PayOut/InsertApprovalDocument',
deletePayOutAccountdetails:env.baseUrl + '/PayOut/DeletePayoutAccountDetails',
checkpayoutAccountdetailsurl:'https://uatapi.fastswiff.com/payment/api/PayOut/GetPayoutAccountdetail',
GetPayoutCreditAllowedAccountsdetails:env.baseUrl + '/PayOut/GetCreditAllowedAccountsdetails',

AddKYCUrl: env.baseUrl  + '/MerchantSettings/KYCDetails',
PayoutAccountFilterData:env.baseUrl + '/PayOut/GetAccountsdetails',
GetPayOutproductcodedatavalidation:'https://uatapi.fastswiff.com/payment/api/PayOut/CheckProductData',
AddPaymentMerchantSpecificSettings:env.baseUrl + "/MerchantSettings/MerchantPaymentReasonSpecificSettings",
GetPayOutReportsUrl: env.baseUrl + '/PayOut/GetPayOutReportsList',
PayOutReportsFilter: env.baseUrl + '/PayOut/GetPayOutReportsFilterInfo',

NewAchTransactionUrl: 'https://uatapi.fastswiff.com/payment/api/Order/OrderPayment',

AddSupportTicketUrl:env.baseUrl + '/Supportticket/Create',
MasterSupportTicketUrl:env.baseUrl + '/Supportticket/GetTicketList',
getTicketdetailsUrl:env.baseUrl + '/Supportticket/Getviewticketdetails',
Addticketdetailsurl:env.baseUrl + '/Supportticket/CreateTicketdetails',
Ticketdetailsurl:env.baseUrl + '/Supportticket/GetTicketdetailsList',
// DocumentUrl:env.baseUrl + '/Supportticket/InsertDocument',
DocumentUrl:env.baseUrl+'/Supportticket/InsertDocument',
GetTicketFilterdataurl:env.baseUrl + '/Supportticket/Getticketfilterdetails',
GetPayoutSecurityTransactionsUrl:env.baseUrl + '/PayOut/GetPayoutSecurityFlagTransactions',


GetMerchantIpAddressDetailsUrl:env.baseUrl + '/MerchantIpAddressConfigurations/GetFilteredMerchantIpAddressConfigList',
InsertMerchantIpAddressConfigDetailsUrl:env.baseUrl + '/MerchantIpAddressConfigurations/InsertMerchantIpAddressConfigDetails',
GetMerchantIpAddressConfigById:env.baseUrl + '/MerchantIpAddressConfigurations/GetMerchantIpAddressConfigById',

ResendPayoutCustomerSecurityEmailUrl:env.baseUrl + '/PayOut/ResendPayoutCustomerSecurtityEmail',
ResendPayoutCustomerSecuritysmsUrl:env.baseUrl + '/PayOut/ResendPayoutCustomerSecurtitySMS',
GetFilteredPayoutSecurityTransactionUrl:env.baseUrl + '/PayOut/GetFilteredPayoutSecurityTransactions',
GetPayoutprocessorurl: env.baseUrl + '/PayOut/GetPayoutProcessorConfiguration',

GetAccountBalance: env.baseUrl + '/PayOut/GetAccountBalance',
ViewAccountBalanceurl: env.baseUrl + '/PayOut/ViewAccountBalance',
Getpayoutkycdetails: env.baseUrl + '/PayOut/GetPayoutKycdetails',


orderdetailsurl:'http://fastswiff.com/merchant3/#/transactions/orderdetails;id=',


verifyadharnum:'https://api.fastswiff.com/merchant/api/Aadhaar/VerifyAadhar',
saveMerchantonboardBusinessDetailsurl: env.baseUrl + '/Account/OnboardingSaveBusinessDetails',
saveonboardCompanyDocuments: env.baseUrl + '/Account/SaveonboardCompanyDocuments',
savelookingdetails: env.baseUrl + '/Account/savebusinessperpousdetails',
saveOnboardOwnerContactDetailsUrl: env.baseUrl + '/Account/OnboardingSaveOwnerContactDetails',
GetOnboardMerchantDetails: env.baseUrl + '/Account/GetOnboardMerchantDetails',


saveOnboardReferenceDetailsUrl: env.baseUrl + '/Account/SaveOnboardReferenceDetails',
saveOnboardBankDetailsurl: env.baseUrl + '/Account/SaveOnboardBankDetails',


saveonboardbusinessdetailUrl: env.baseUrl + '/Account/SaveOnboardBusinessdetails',
SaveOnboardBusinessOwnerDetailsUrl: env.baseUrl + '/Account/SaveOnboardBusinessOwnerDetails',
MerchantOnboardFileUpload: env.baseUrl + '/Account/Onboardupload',

AddAllowTransactionMerchantSpecificSettings:env.baseUrl + "/MerchantSettings/MerchantAllowDuplicateTranSpecificSettings",
PayoutconfigDefaultAccounturl:env.baseUrl + '/PayOut/PayOutProcessorConfigAccount',
getresellerdatabasedonurl: env.baseUrl + '/User/GetResellerDetailsBasedonUrl',
getresellerlogoUrl:env.baseUrl + '/User/GetResellerLogoData',
GetFundreportfilterurl:env.baseUrl + '/Transaction/GetFundreportfilterdetails',

saveonoardingTable: 'https://api.fastswiff.com/merchant/api/Merchantlevel/SaveboardingHistory',
UpdateBankdetailsstatus: 'https://api.fastswiff.com/merchant/api' + '/Merchantlevel/UpdateMerchantBankdetails',
VerifyingBankdetails:'https://uatapi.fastswiff.com/payment/api/PayOut/FundTransfer2',
 CheckFundBankTransferdetails:'https://uatapi.fastswiff.com/payment/api/PayOut/FundStatus',
 merchantagreementurl:'https://fastswiff.com/merchant/#/settings/merchantagreement',
 GetPostbackdatafilterurl:env.baseUrl + '/Transaction/GetPostbackdatafilter',

ApproveAadhar: 'https://api.fastswiff.com/merchant/api' + '/Merchantlevel/ApproveAadhardetails',
GetpayoutposbackdataUrl:env.baseUrl + '/Transaction/Getpayoutposbackdata',
GetPayoutPostbackdatafilterurl:env.baseUrl + '/Transaction/GetPayoutPostbackdatafilter',
// fundtransfermakerurl:'https://uatapi.fastswiff.com/payment/api/PayOut/CraeteFundTransferMaker',
fundtransfermakerurl:'https://api.fastswiff.com/virtualPOS/api/PayOut/CraeteFundTransferMaker',
payoutfundbanktransferurl:env.baseUrl + '/PayOut/PayoutFundBankTransfer',
gettransactiondetails: env.baseUrl + '/Transaction/GetTransactiondetailsByuniqueid',
GetPaymentLedgerDetailViewUrl:env.baseUrl + '/Transaction/GetPaymentLedgerDetailView',

MerchantAddressSpecificSettings:env.baseUrl + "/MerchantSettings/MerchantAddressSpecificSettings",

GetuserdetailsbyUserid: env.baseUrl + '/User/GetUserDetailsBasedOnUserId',
Zipcodedetailsurl:env.baseUrl + '/AddOnBusinessAccount/Zipcodedetails',
Declinepayouttransaction:env.baseUrl + '/PayOut/DeclinePayoutTransaction',

getRoleBasedPermissions:env.baseUrl + '/User/GetRoleBasedPermissions',
MerchantZipCodeSpecificSettings:env.baseUrl + "/MerchantSettings/MerchantZipCodeSpecificSettings",
ValidateBankdetails:env.baseUrl + '/Account/GetBankaccountdetailsbasedonmid',
savebankaccountdetails:env.baseUrl + "/Account/SaveOnboardingBankAccountDetails",
Updatebankacctdetailsurl:env.baseUrl + '/Account/UpdateBankAccountdetailsbasedonmid',
GetPayoutBalanceReportUrl:env.baseUrl + '/Transaction/GetPayoutBalanceReport',
GetPayoutBalanceReportfilterUrl:env.baseUrl + '/Transaction/GetPayoutBalanceReportFilter',

saveSessionToken:env.baseUrl + '/Account/SaveUserSessionTokens',


InitiateApplicationOtpUrl:'https://uatapi.fastswiff.com/Merchant/api' + '/ApplicationSecurity/InitiateApplicationOtp',
ValidateApplicationOtpUrl:'https://uatapi.fastswiff.com/Merchant/api' + '/ApplicationSecurity/ValidateApplicationOtp',
MerchantOrderExpirySpecificSettings:env.baseUrl + "/MerchantSettings/MerchantOrderExpirySpecificSettings",
ReconciliationReportUrl:env.baseUrl + "/Reports/GetReconciliation",
getBoardingdataUrl:env.baseUrl + '/Transaction/GetBoardingDocuments',
getMIDWithMerchantIdUrl:env.baseUrl + '/Account/GetMIDWithMerchantId',
GetMerchantServicesAndFeesUrl:env.baseUrl + '/Account/GetMerchantServicesAndFees',

GetMerchantWalletDetailsUrl:env.baseUrl + '/Account/GetMerchantWalletDetails',
GetMerchantProductServicesAndFeesUrl:env.baseUrl + '/Account/GetMerchantProductServicesAndFees',


PayOutMerchantSettings:env.baseUrl + '/MerchantSettings/PayOutMerchantSettings',
PayOutCustomerSettings:env.baseUrl + '/MerchantSettings/PayOutCustomerSettings',
Transactioncountforrefund: env.baseUrl + "/Transaction/TransactionDetailscountforrefund",
CheckAadhaarBasedESignUrl:env.baseUrl + '/User/ESignAadhar',
IdfyCheckAadhaarBasedESignUrl:env.baseUrl + '/User/ESignAadharIdfy',
getrefundtransactionsurl: env.baseUrl + '/Transaction/Getrefundtransactions',
gettransactiondatasurl: env.baseUrl + '/Transaction/GetTransactiondatabyid',
filterOrderFailureLogsUrl:env.baseUrl+'/Reports/GetFilteredOrderFailureLogsList',
ViewOrderFailureLogDetailsUrl:env.baseUrl+'/Reports/OrderFailureLogDetails',
filterPayoutFailureLogsUrl: env.baseUrl+'/Reports/GetFilteredPayoutFailureLogsList',
ViewPayoutFailureLogDetailsUrl:env.baseUrl+'/Reports/PayoutFailureLogDetails',
IsraisedsupportTicket:env.baseUrl+'/Transaction/IsraisedsupportTicket',
GetInstantPaymentTransactionUrl: env.baseUrl + '/Transaction/GetInstantPaymentTransactions',
SignzyCheckAadhaarBasedESignUrl:env.baseUrl + '/User/ESignAadharSignzy',


AddBusinesscategory:env.baseUrl + '/AddOnBusinessAccount/AddCategoryType',
AddSubCategoryType:env.baseUrl + '/AddOnBusinessAccount/AddSubCategoryType',
GetCategoryType:env.baseUrl + '/AddOnBusinessAccount/GetBusinessTypeDetails',
CallGenerateEinvoice:'https://api.fastswiff.com/POS/api'+'/Order/CallGenerateEinvoice',

GetType:env.baseUrl + '/AddOnBusinessAccount/GetTypeDetails',
GetSubType:env.baseUrl + '/AddOnBusinessAccount/GetSubTypeDetails',
AddStoreSpecificSettings:env.baseUrl+ "/MerchantSettings/NearByStoreSettings",

//EwayBill
PrintEwayBillDetails:'https://einvapi.charteredinfo.com/aspapi/v1.0/printdetailewb',
BusinessProFileItemFileUplod:env.baseUrl + '/AddOnBusinessAccount/UpdateBusinessAccountLogo',
verifyadharnumber:'https://api.fastswiff.com/merchant/api'+'/KycVerificationProcess/RequestAadharOtp',
submitaadharotp:'https://api.fastswiff.com/merchant/api'+'/KycVerificationProcess/SubmitAadharOtp',
savekycverificationtable: 'https://api.fastswiff.com/merchant/api'+'/Merchantlevel/SaveKycdetials',


MerchantstatementData: env.baseUrl + "/Reports/GetMerchantStatementReport",
GetMerchantBatchesfilter: env.baseUrl + "/Batch/GetMerchantBatcheReport",
savesaveAadhardetailUrl:env.baseUrl + '/Account/UpdateAadhardetails',
getVendorDetailsUrl: env.baseUrl+ "/Account/GetVendorDetails",
GetBankList:env.baseUrl+ '/MerchantSettings/BankList',
verifyaadharsubmission:'https://api.fastswiff.com/merchant/api'+'/KycVerificationProcess/Isverifiedaadharcard',
getKycDataUrl:env.baseUrl + '/MerchantSettings/KycBoardingData',
profileupdate: 'https://api.fastswiff.com/dashboard/api' + '/UserProfile/EditMMSUserProfile',
Logout:env.baseUrl + '/User/UserLogOut',



SaveBookingTicketCategoryUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/SaveBookingTicketCategory',
FilteredBookingTicketCategoryListUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/GetFilteredBookingTicketCategories',
GetBookingTicketCategoryInfoUrl:'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/GetBookingTicketCategory',
SaveBookingTicketTemplateUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/SaveBookingTicketTemplates',
 GetBookingTicketTemplateUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/GetBookingTicketTemplates',
 GetActiveBookingTicketCategoryListUrl:'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/GetActiveBookingTicketCategories',
 SaveBookingProfileImageUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/SaveBookingProfileImage',
 GetActiveTemplateListUrl:'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/GetActiveBookingTicketTemplates',
 SaveBookingTemplateImageUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/SaveBookingTemplateImage',
 SaveBookingTicketMerchantSettingsUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/SaveBookingTicketMerchantSettings',
 BookingTicketZipcodeurl: 'https://api.fastswiff.com/virtualPOS/api' + '/Merchant/GetPincodedetails',

 GetBookingTicketJsonFileUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/GetBookingTicketJsonFile',
 BookingCreateTicketUrl:"https://fastswiff.com/consumer/" + '#/booking/create-booking?bookingCode=',
 GetBookingTicketMerchantSettingUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/GetBookingTicketMerchantSettings',
 GetPopupGeneralizedMessage:'https://api.fastswiff.com/virtualPOS/api'+ '/MerchantSettings/GetPopupGeneralizedMessage',
 GetBookingTicketDashboard: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/GetBookingTicketDashboard',
 CheckBookingShortCodeExistUrl: 'https://api.fastswiff.com/virtualPOS/api' + '/BookingTicket/CheckBookigShortCodeExists',
 getdefaultlanguage: env.baseUrl + '/UserProfile/GetDefaultLang',
 ChangeUserPasswordUrl: env.baseUrl + '/user/ChangeUserPassword',
 disableUserKycAndUserProfileApiCall: false,
    verifyOtpUrl:'https://uatapi.fastswiff.com/virtualPOS/Api'+'/User/VerifyOtp',
  sendOTPUrl:'https://uatapi.fastswiff.com/virtualPOS/Api'+'/User/SendOtp',
  GetMerchantAgreementDetails:'https://uatapi.fastswiff.com/virtualPOS/Api'+ '/MerchantSettings/GetMerchantAgreementDetails',
  GetAgreementDownloadFile:'https://uatapi.fastswiff.com/virtualPOS/Api'+ '/MerchantSettings/GetAgreementDownloadFile',

  ESignRequestWithDigio:'https://api.fastswiff.com/dashboard/Api'+'/User/ESignRequest',
  ESignStatusRequestWithDigio:'https://api.fastswiff.com/dashboard/Api'+'/User/ESignStatusRequest',
  ESignUploadDocument:'https://api.fastswiff.com/dashboard/Api'+'/User/UploadDocument',
  GetEsignType:'https://uatapi.fastswiff.com/virtualPOS/Api'+ '/MerchantSettings/GetEsignType',
  GetMerchantAgreementDigioStatusUrl: 'https://api.fastswiff.com/dashboard/api' + '/OnBoarding/GetMerchantAgreementDigioStatus',


  SecurityKey: '5705908842978473',
  ON_BOARD_API_URL: 'https://api.fastswiff.com/dashboard/api/Account/',
  ON_BOARD_USER_API: '  https://api.fastswiff.com/dashboard/api/User/',
  EncryptKey: '4512631236589784',
  EncryptIV: '4512631236589784',

  InsertorUpdatePepDetailsUrl: env.baseUrl  + '/User/InsertorUpdatePepDetails',
  BusinessProductDescdetailsUrl: env.baseUrl  + '/User/InsertorUpdateBusinessProductDescriptiondetails',
  GetPepDetailsandBusinessProddetailsUrl: env.baseUrl  + '/User/GetPepDetailsandBusinessProddetails',
  GetMISList: "https://api.fastswiff.com/dashboard/api" + '/Reports/misReport',
  getMerchantAgreementList:'https://api.fastswiff.com/mscommonService/api/Kyc/GetMerchantagreementsList',
  InternalAuthenticate: env.baseUrl + '/User/InternalAuthenticate',
    //Accounting Api's
    AddSupplierDetails: 'https://api.fastswiff.com/mscommonservice/api/BalanceSheet/ManageCustomerInfoBases',
    AddItemAndServices: 'https://api.fastswiff.com/mscommonservice/api/BalanceSheet/ManageItemsAndServices',
    VoucherBasicDetail: 'https://api.fastswiff.com/mscommonservice/api/BalanceSheet/voucher-basic-details', 
    VoucherOtherDetail: 'https://api.fastswiff.com/mscommonservice/api/BalanceSheet/',
    GetHSNCodeDetails: 'https://api.fastswiff.com/mscommonservice/api/BalanceSheet/GetHSNCodeDetails',
    orderCreate: 'https://api.fastswiff.com/pos/api/Order/Create',
    UploadDocument: 'https://api.fastswiff.com/msformservice/api/Form/UploadDocument',
};



